// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__18007","load6":"Spinner_load6__1gouI","round":"Spinner_round__2JpAK"};